import { Flex } from '@kanvas/andromeda';
import styled from 'styled-components/native';
import colors from 'theme/colors';

const Screen = styled(Flex)`
  background-color: ${colors.WHITE};
`;

export default Screen;